import * as postcardMarketing from './postcard-marketing-home-services';
import * as automatedFollowUp from './5-automated-follow-up-sequences';
import * as buildingReferralEngine from './building-a-referral-engine';
import * as builtForHomeServices from './built-for-home-services-vs-generic';
import * as crmPricingBreakdown from './crm-pricing-breakdown-comparison';
import * as customerCommunication from './customer-communication-that-closes';
import * as fromQuoteToCash from './from-quote-to-cash-faster-invoicing';
import * as estimateSigning from './how-estimate-signing-works';
import * as marketingListsGuide from './marketing-lists-guide';
import * as reportingRevenueLeaks from './reporting-that-reveals-revenue-leaks';
import * as trueCostMissedLead from './true-cost-of-missed-lead';

export interface MarkdownBlogPost {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  image?: string;
  content: string;
}

// Registry of all markdown blog posts
export const markdownPosts: Record<string, MarkdownBlogPost> = {
  [postcardMarketing.meta.slug]: {
    ...postcardMarketing.meta,
    content: postcardMarketing.content
  },
  [automatedFollowUp.meta.slug]: {
    ...automatedFollowUp.meta,
    content: automatedFollowUp.content
  },
  [buildingReferralEngine.meta.slug]: {
    ...buildingReferralEngine.meta,
    content: buildingReferralEngine.content
  },
  [builtForHomeServices.meta.slug]: {
    ...builtForHomeServices.meta,
    content: builtForHomeServices.content
  },
  [crmPricingBreakdown.meta.slug]: {
    ...crmPricingBreakdown.meta,
    content: crmPricingBreakdown.content
  },
  [customerCommunication.meta.slug]: {
    ...customerCommunication.meta,
    content: customerCommunication.content
  },
  [fromQuoteToCash.meta.slug]: {
    ...fromQuoteToCash.meta,
    content: fromQuoteToCash.content
  },
  [estimateSigning.meta.slug]: {
    ...estimateSigning.meta,
    content: estimateSigning.content
  },
  [marketingListsGuide.meta.slug]: {
    ...marketingListsGuide.meta,
    content: marketingListsGuide.content
  },
  [reportingRevenueLeaks.meta.slug]: {
    ...reportingRevenueLeaks.meta,
    content: reportingRevenueLeaks.content
  },
  [trueCostMissedLead.meta.slug]: {
    ...trueCostMissedLead.meta,
    content: trueCostMissedLead.content
  }
};

// Helper to get a post by slug
export const getMarkdownPost = (slug: string): MarkdownBlogPost | null => {
  return markdownPosts[slug] || null;
};

// Helper to check if a slug is a markdown post
export const isMarkdownPost = (slug: string): boolean => {
  return slug in markdownPosts;
};

// Get all markdown posts as an array (for listing)
export const getAllMarkdownPosts = (): MarkdownBlogPost[] => {
  return Object.values(markdownPosts);
};
